import { apiDelete, apiGet, apiPost, apiPut } from "../utils/api";

/**
 * Service pour gérer les anniversaires via le backend
 */

/**
 * Récupère tous les anniversaires
 * @returns {Promise<Array>} Liste des anniversaires
 */
export async function fetchBirthdays() {
  try {
    const response = await apiGet("/birthdays");
    return response.data || [];
  } catch (error) {
    console.error("Erreur lors de la récupération des anniversaires:", error);
    throw error;
  }
}

/**
 * Récupère les anniversaires d'aujourd'hui
 * @returns {Promise<Array>} Liste des anniversaires du jour
 */
export async function fetchTodayBirthdays() {
  try {
    const response = await apiGet("/birthdays/today");
    return response.data || [];
  } catch (error) {
    console.error(
      "Erreur lors de la récupération des anniversaires du jour:",
      error
    );
    throw error;
  }
}

/**
 * Crée un anniversaire
 * @param {Object} data
 * @param {string} data.username
 * @param {number} data.month
 * @param {number} data.day
 * @returns {Promise<Object>} Anniversaire créé
 */
export async function createBirthday({ username, month, day }) {
  try {
    const response = await apiPost("/birthdays", { username, month, day });
    return response.data;
  } catch (error) {
    console.error("Erreur lors de la création de l'anniversaire:", error);
    throw error;
  }
}

/**
 * Met à jour un anniversaire
 * @param {number} id
 * @param {Object} data
 * @param {string} data.username
 * @param {number} data.month
 * @param {number} data.day
 * @returns {Promise<Object>} Anniversaire mis à jour
 */
export async function updateBirthday(id, { username, month, day }) {
  try {
    const response = await apiPut(`/birthdays/${id}`, { username, month, day });
    return response.data;
  } catch (error) {
    console.error("Erreur lors de la mise à jour de l'anniversaire:", error);
    throw error;
  }
}

/**
 * Supprime un anniversaire
 * @param {number} id
 * @returns {Promise<void>}
 */
export async function deleteBirthday(id) {
  try {
    await apiDelete(`/birthdays/${id}`);
  } catch (error) {
    console.error("Erreur lors de la suppression de l'anniversaire:", error);
    throw error;
  }
}

